const URIs: { [k: string]: string } = {
    exhibitor_request_uri: "/jobstack/exhibitors-requests",
    speakers_uri: "/jobstack/speakers-jobstack",
    exhibitors_uri: "/jobstack/exhibitors-jobstack",
    tickets_uri: "/jobstack/tickets"
};

export default URIs;
